import { useSelector } from 'react-redux';
import LoadingEllipsis from '@/components/LoadingEllipsis';

const GlobalCurtain = () => {
  const { showGlobalCurtain } = useSelector((state) => state.config);

  if (!showGlobalCurtain) return <></>;

  return (
    <div
      style={{ background: 'rgba(50, 56, 67, 0.7)' }}
      className="fixed inset-0 z-full flex items-center text-blue-400 justify-center"
    >
      <LoadingEllipsis width={50} />
    </div>
  );
};

export default GlobalCurtain;
